// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__4ADCA","title":"AfterFrontImage_title__X6plV"};